<template>
  <div class="pt-0">
    <CurvedBottomNavigation
      :options="options"
      v-model="selected"
      foreground-color="#edf1f5"
    >
      <template #icon="{ props }">
        <span
          :class="[
            props.icon,
            props.icon === 'icon-home-page' ? 'p-fs-xxxl' : 'p-fs-xbig',
          ]"
        >
          <span class="path1"></span>
          <span class="path2"></span>
          <span class="path3"></span>
          <span class="path4"></span>
        </span>
      </template>
      <template #title="{ props }">
        <b class="p-fs-s">{{ props.title }}</b>
      </template>
    </CurvedBottomNavigation>
  </div>
</template>

<script>
import alert from "@/lang/AlertMessages.js";
import label from "@/lang/StaticLabels.js";
import { CurvedBottomNavigation } from "bottom-navigation-vue";

export default {
  name: "TheMenu",
  components: {
    CurvedBottomNavigation,
  },
  data() {
    return {
      alert,
      label,

      selected: 1,
      options: [
        {
          id: 4,
          icon: "icon-credit-card",
          title: "اعتبار",
          path: { name: "Credit" },
        },
        // {
        //   id: 3,
        //   icon: "icon-discount-menu",
        //   title: "تخفیف‌ها",
        //   path: { name: "" },
        // },
        {
          id: 2,
          icon: "icon-survey",
          title: "نطرسنجی",
          path: { name: "FeedbackList" },
        },
        {
          id: 1,
          icon: "icon-home-page",
          title: "خانه",
          path: { name: "Home" },
        },
      ],
    };
  },
};
</script>
<style lang="sass">
.checked .active-label
  background-image: linear-gradient(to bottom, #ff5064 0%, #ff801c 81%, #ff801c 100%)!important
  // background-color: #ff5064 !important
  span .path1:before
    color: #fff
  span .path2:before
    color: #fff
  span .path3:before
    color: #fff
  span .path4:before
    color: #fff
.checked .btn-title
  color: #FF5644 !important
.unchecked .btn-title
  color: #45376d !important

  
</style>
